import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, Observable } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { IMessage } from '../interfaces/chat.interface';
import { ChatEventType } from '../enums/chat.enum';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class WebSocketService {
    private socket: Socket;
    private isConnected$ = new BehaviorSubject<boolean>(false);

    constructor() {
        console.log('WebSocketService constructor called');
        console.log('WebSocket URL:', environment.webSocketUrl);
        this.socket = io(environment.webSocketUrl, { autoConnect: false });
    }

    connect(): void {
        console.log('WebSocketService connect() called');
        
        // Set up event listeners first
        this.socket.on(ChatEventType.Connect, () => {
            console.log('WebSocket Connected:', this.socket?.connected);
            console.log('WebSocket Socket ID:', this.socket?.id);
            this.isConnected$.next(true);
        });

        this.socket.on(ChatEventType.Disconnect, () => {
            console.log('Disconnected');
            this.isConnected$.next(false);
        });

        this.socket.on('error', (error) => {
            console.error('Socket.IO error:', error);
        });

        this.socket.on('connect_error', (error) => {
            console.error('Socket.IO connect_error:', error);
        });

        // Now connect
        console.log('Attempting to connect WebSocket...');
        this.socket.connect();
    }

    onConnected(): Observable<boolean> {
        return this.isConnected$.pipe(filter((connected) => connected));
    }

    joinRoom(id: string) {
        if (this.socket) {
            this.socket.emit(ChatEventType.JoinChannel, id);
        }
    }

    listenForNewMessages(): Observable<IMessage> {
        return new Observable((observer) => {
            if (this.socket) {
                this.socket.on(ChatEventType.NewMessage, (message) => {
                    observer.next(message);
                });
            }
        });
    }

    joinNotificationChannel(userId: string): void {
        if (this.socket) {
            this.socket.emit(ChatEventType.JoinNotificationChannel, userId);
        }
    }

    listenForNotifications(): Observable<{ hasUnreadNotifications: boolean }> {
        return new Observable((observer) => {
            if (this.socket) {
                this.socket.on(ChatEventType.NotificationReceived, (data) => {
                    observer.next(data);
                });
            }
        });
    }

    joinContractChannel(projectId: string): void {
        if (this.socket) {
            this.socket.emit(ChatEventType.JoinContractChannel, projectId);
        }
    }

    listenForContractUpdates(): Observable<{
        contractId: string;
        status: string;
        projectId: string;
        updatedAt: string;
    }> {
        return new Observable((observer) => {
            if (this.socket) {
                this.socket.on(ChatEventType.ContractStatusUpdated, (data) => {
                    observer.next(data);
                });
            }
        });
    }
}
